import React from 'react'; 
import { loadAnalytics } from "./withTracker";
const config = require('./config');
const APPID = config.ids.appId;
const Loading = require('./loading');
 import cookie from 'react-cookie';
 import { hashHistory  } from 'react-router'
class Promobuddytracking extends React.Component {

 componentWillMount() {
	   const tokenId = this.props.params.tokenId;
	    if(typeof tokenId !== "undefined" && tokenId !== null &&  APPID ===  tokenId) {
				   cookie.save('ispromobuddyOrder','Yes');
				     	 hashHistory.push("/");
		}
 }
	
 componentDidMount(){
		 loadAnalytics();
  }	    
  render() { return (<div className="container-fluid desktop-container"> 
            <div className="row">
               <Loading/>
            </div>
        </div> );
	 }
 }
 export default Promobuddytracking;



// WEBPACK FOOTER //
// ./src/Promobuddytracking.js